// client/clientTranslator.ts
import { Language } from "../languages.js";
import { Translator } from "../translation.js";
import { globalLanguageSubject } from "./languageSubject.js";
var clientTranslator = new Translator({
  dictionary: {},
  languages: [Language.GERMAN, Language.ENGLISH],
  getSelectedLanguage() {
    return globalLanguageSubject.getValue();
  },
  selectLanguage(lang) {
    globalLanguageSubject.next(lang);
  },
  onDictionaryUpdate() {
    globalLanguageSubject.next(globalLanguageSubject.getValue());
  }
});
export {
  clientTranslator
};
